import { type ReactNode } from 'react';

type Props = { className?: string };

const BASE = 'relative inline-flex h-2 w-2';

export function PulseDot({ className = '' }: Props): ReactNode {
  return (
    <span className={`${BASE} ${className}`}>
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-red opacity-75" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-brand-red" />
    </span>
  );
}
